if(!window.SwymCallbacks){window.SwymCallbacks = [];}
window.SwymCallbacks.push(function(){
_swat.fetchWrtEventTypeET(function(products){
   // render products - array of objects with same structure as productData
   // {{Insert your rendering function}}
   // products count - products.length
   // {{Insert your count update}}
   console.log('wlp', products);
      
   products.forEach(function(item, index){
    var json = JSON.stringify(item);
     
    var clean_meta = '';
    const d = new Date(item.cprops.date);
    const month = getTextMonth(d.getMonth());
    const day = d.getDate();
    const year = d.getFullYear();
    const formatted_date = `${ month } ${day}, ${year}`;
    console.log(`${ month} ${day} ${year}`);
    
    if(item.vi != null){
      clean_meta = item.vi;
    }
    
    
    console.log('clean_meta', clean_meta);
    
    if( clean_meta.includes(',,') || clean_meta.includes(',Yes,') || clean_meta.includes(',No,')  ){
    
      clean_meta = clean_meta.replace(",,", " bed,,").replace(",Yes,", " bed,Yes,").replace(",No,", " bed,No,").replace(",,", " | ").replace(",Yes,", " w/track ").replace(/,/g, " | ").replace("track", "track | ").replace("| No |", " | ");
    
      var year_text = clean_meta.substr(clean_meta.lastIndexOf("|"));
      var new_text = clean_meta.replace(year_text, "");
      var color_text = "";
      var anchor_text = "";

      year_and_color_text = year_text.replace("| ", "");
      color_text = year_and_color_text.substr(year_and_color_text.indexOf(' ') + 1);
      year_text = year_and_color_text.substr(0,year_and_color_text.indexOf(' '));
      
      
      if(item.ct == 'DiamondBack HD') {
        anchor_text = color_text.substr(color_text.lastIndexOf(' ') + 1, color_text.length );
        color_text = color_text.substr(0, color_text.lastIndexOf(' ') + 1 );
        
        console.log(anchor_text);
        
      }
        
      new_text = `${year_text} | ${new_text}`;

      clean_meta = new_text.split(" | ");
      // clean_meta = clean_meta.split("|");
      console.log(clean_meta);
      console.log(new_text);
      
      if(item.ct == 'DiamondBack HD') {
        clean_meta = `<span>Vehicle: </span>${clean_meta[0]} | ${clean_meta[1]} | ${clean_meta[2]} | ${clean_meta[3]}<br/><span>Color: </span>${color_text}<br/><span>Anchor Cleats: </span>${anchor_text}`;
      }else {
        clean_meta = `<span>Vehicle: </span>${clean_meta[0]} | ${clean_meta[1]} | ${clean_meta[2]} | ${clean_meta[3]}<br/><span>Color: </span>${color_text}`;
      }
    }
     
     $('#wl_container').append(`<div>
     <div class="col1">
     <img src="${item.iu}" width="150" />
     </div>
     <div class="col2">
     <h3><a href="${item.du}">${item.dt}</a></h3>
     <span class="meta" >${formatted_date}</span>
     <!--<span class="meta" >${clean_meta}</span>-->
     </div>
     <div class="col3">
     <span class="price" >$${item.pr}</span>
     </div>
     <div class="col4 actions" >
       <div class="action-nav">
         <!--<a data-product-index="${index}" class="btn-rfwl" ><img src="https://cdn.shopify.com/s/files/1/1571/5355/files/remove.png?13494219212570558665" alt="remove" /></a>-->
         <!--<a href="${item.du}">View Product</a>-->
       </div>
       <div class="action-buttons">
        <button data-product-index="${index}" class="btn btn-atc" >Add To Cart</button>
        <a data-product-index="${index}" class="btn-rfwl" ><img src="https://cdn.shopify.com/s/files/1/1571/5355/files/remove.png?13494219212570558665" alt="remove" /></a>
       </div>
     </div>`);
   });
   
  window._swat.generateSharedWishlistURL(
    null,
    function(data) { 
      console.log('wl_url', data); 
      $('#send_wl_url').val(data);
      $('#send_wl_url').click(function(){
        var copyText = document.getElementById("send_wl_url");
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        navigator.clipboard.writeText(copyText.value);
        
        $('#send_wl_url_alert').addClass('active');
        setTimeout(function(){
          $('#send_wl_url_alert').removeClass('active');
        }, 2000);
        
      });
    },     // returns the generated url
    function(data) { console.log('wl_url_error', data); }
  );
   
   $('.btn-atc').click(function(){
     var index = $(this).attr('data-product-index');
     var obj = products[index];
     
     _swat.replayAddToCart(obj, obj.epi, function() {
      // Successfully added, open cart
      // _swat.openCartPage();
    });
   });
   
   $('.btn-rfwl').click(function(){
     var index = $(this).attr('data-product-index');
     var obj = products[index];
     
     _swat.removeFromWishList(obj, function callback() {
          console.log(obj.id);
          location.reload();
      });
    });
   
   $('.btn-sendlist').click(function(){
      var emailId = $('#send_wl_form_to_email').val();
      console.log(emailId);
      var fromEmailId = $('#send_wl_form_from_email').val();
      console.log(fromEmailId);
      var noteTxt = 'testing';
    
      _swat.sendEmailWishList(function callback() {
        console.log('Email sent');
      }, emailId, fromEmailId, noteTxt);
    });
   
   // di, id, lid, pid
 }, _swat.EventTypes.addToWishlist);});
 
 function removeFromWishlist(id){
    // console.log(`delete item: ${item}`);
    
    _swat.deleteEvent(function callback() {
      console.log(id);
    }, id);
      

  }

 function addToCartFromWishlist(obj, epi){
   
  _swat.replayAddToCart(JSON.parse(obj), epi, function() {
    // Successfully added, open cart
    _swat.openCartPage();
  });

 }


function getTextMonth(number){
  switch (number) {
    case 1:
      return 'Jan'
      break;
    case 2:
      return 'Feb'
      break;
    case 3:
      return 'Mar'
      break;
    case 4:
      return 'Apr'
      break;
    case 5:
      return 'May'
      break;
    case 6:
      return 'Jun'
      break;
    case 7:
      return 'Jul'
      break;
    case 8:
      return 'Aug'
      break;
    case 9:
      return 'Sep'
      break;
    case 10:
      return 'Oct'
      break;
    case 11:
      return 'Nov'
      break;
    case 12:
      return 'Dec'
      break;
  
    default:
      break;
  }
}